export enum LocalStorageKeys {
  LOCALE = 'locale',
  // VERIFY_EMAIL_RESEND_STATE used to hold a ten minute countdown between
  // resends, keyed on the account. The address is editable now, so a countdown
  // tied to one of them would either block a corrected address or be trivially
  // stepped around by editing it. The rate limit that matters is the api's.
  DOCUMENTS_LIST_MODE = 'document_list_mode',
  NOTIFICATIONS_ONE_ON_ONE_CHAT_UNSEEN_COUNT = 'notifications_one_on_one_chat_unseen_count',
  NOTIFICATIONS_INTERESTS_CHAT_UNSEEN_COUNT = 'notifications_interests_chat_unseen_count',
  NOTIFICATIONS_BOARD_CHAT_UNSEEN_COUNT = 'notifications_board_chat_unseen_count',
  NOTIFICATIONS_BOARD_QUESTIONS_CHAT_UNSEEN_COUNT = 'notifications_board_questions_chat_unseen_count',
  NOTIFICATIONS_RESIDENTS_QUESTIONS_CHAT_UNSEEN_COUNT = 'notifications_residents_questions_chat_unseen_count',
}
